<template>
  <div style="width: 100%">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'Admin',
  data: () => ({
    windowSize: 0,
  }),
  methods: {
    resizeHandler() {
      this.windowSize = window.innerWidth;
    },
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
};
</script>

<style scoped>

</style>
